module.exports = __webpack_public_path__ + "img/blaked-ingredients.1f2b8c31.svg";